var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 24,
    viewBox: "0 0 8 24",
    fill: "#67678b",
    opacity: 0.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.5c1.795 0 3.25 1.455 3.25 3.25S5.795 24 4 24 .75 22.545.75 20.75 2.205 17.5 4 17.5zm0-8.75c1.795 0 3.25 1.455 3.25 3.25S5.795 15.25 4 15.25.75 13.795.75 12 2.205 8.75 4 8.75zM4 0c1.795 0 3.25 1.455 3.25 3.25S5.795 6.5 4 6.5.75 5.045.75 3.25 2.205 0 4 0z",
    transform: "translate(-1042 -130) translate(1024 121) translate(18 9)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVertical);
export default __webpack_public_path__ + "static/media/menu-vertical.1b11fa50.svg";
export { ForwardRef as ReactComponent };